module.exports = __webpack_public_path__ + "img/donante-mujer-actual.9af9298a.jpeg";